<template>
    <v-dialog
      v-model="activeM"
      width="800px"
    >
    <loader :active.sync="isLoading" 
            :can-cancel="false" 
            :on-cancel="onCancel"
            :loader="'bars'"
            :color="'#0066ff'"
            :height="100"
            :width="100"
            :is-full-page=true>
        </loader>
      <v-card>
        <v-card-title class="grey darken-2">
          Create contact
        </v-card-title>
        <v-container grid-list-sm>
          <v-layout
            wrap
          >
            <v-flex
              xs12
              align-center
              justify-space-between
            >
              <v-layout align-center>
                <v-avatar
                  size="40px"
                  class="mr-4"
                >
                <!-- src="//ssl.gstatic.com/s2/oz/images/sge/grey_silhouette.png" -->
                  <img
                    src="https://rubiesstore.s3.amazonaws.com/696969.png"
                    alt=""
                  >
                </v-avatar>
                <v-text-field
                  placeholder="Group Name"
                  v-model="newGroup.groupname"
                ></v-text-field>
              </v-layout>
            </v-flex>
            <v-flex xs12>
                <v-select
                :items="cates"
                label="Group Category"
                v-model="newGroup.grouptype"
                prepend-icon="category"
                >
                </v-select>
            </v-flex>
            <v-flex xs12>
              <v-select
                :items="jtypes"
                label="Join Type"
                v-model="newGroup.jointype"
                prepend-icon="list"
                ></v-select>
            </v-flex>
            <v-flex xs12>
              <v-textarea
                class="mx-2"
                label="Group Description"
                rows="1"
                v-model="newGroup.groupdesc"
                prepend-icon="notes"
                ></v-textarea>
            </v-flex>
          </v-layout>
        </v-container>
        <v-card-actions>
          <!-- <v-btn
            text
            color="primary"
          >More</v-btn> -->
          <v-spacer></v-spacer>
          <v-btn
            text
            color="primary"
            @click="dialogactive = false"
          >Cancel</v-btn>
          <v-btn
            text
            @click="createGroup"
          >Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
</template>
<script>
export default {
    props:{
        dialogactive: Boolean,
    },
    data() {
        return {
            isLoading: false,
            cates:[],
            categories:[],
            jtypes:[
                "free", "invitation"
            ],
            newGroup:{
                phonenumber: localStorage.phonenumber, 
                source: "Web", 
                groupname: "", 
                groupdesc: "",
                jointype: "",
                grouptype: "",
                groupcategory: "",

            }
        }
    },
    computed:{
        
    },
    methods: {
        doLoading() {
            this.isLoading = true;
            
            // simulate AJAX
            
            setTimeout(() => {
                this.isLoading = false
            },5000)
        },
        onCancel() {
            console.log('User cancelled the loader.')
        },
        createGroup(){
            this.isLoading = true;
            
            var str = this.newGroup.grouptype;
            this.newGroup.groupcategory = str.toUpperCase();
            fetch('https://shwvr4uwyh.execute-api.us-east-1.amazonaws.com/dev/creategroup',{
                    method: 'post',
                    body: JSON.stringify(this.newGroup),
                    headers: {
                     'content-type':'application/json'
                    }
                })
                .then(res => res.json())
                .then(res => {
                    console.log(res);
                    
                    if(res.responsecode == "00")
                    {
                        console.log(res);
                        this.isLoading = false;
                        this.dialogactive = false
                        this.$swal.fire(
                            'Success',
                            res.responsemessage,
                            'success'
                        );
                        this.fetchGroups();
                    }else{
                        this.isLoading = false;
                        this.$swal.fire(
                            'Errorr Code: '+res.responsecode,
                            res.responsemessage,
                            'error'
                        )
                    }
                    
                    
                })
                .catch(err => console.log(err))
        },

        fetchCategories(){
            fetch('https://shwvr4uwyh.execute-api.us-east-1.amazonaws.com/dev/getcategories',{
                    method: 'post',
                    body: JSON.stringify({you:"you"}),
                    headers: {
                     'content-type':'application/json'
                    }
                })
                .then(res => res.json())
                .then(res => {
                    console.log(res);
                    
                    if(res.responsecode == "00")
                    {
                        console.log(res);
                        this.categories = res.data;
                        for (let i = 0; i < this.categories.length; i++) {
                            this.cates[i] = this.categories[i].name;
                        }
                        console.log(this.cates);
                    }else{
                        this.$swal.fire(
                            'Errorr',
                            res.responsemessage,
                            'danger'
                        )
                    }
                    
                })
                .catch(err => console.log(err))

        }
    },
    computed: {
        activeM:{
            get: function(){
                return this.dialogactive;
            },
            set: function(newValue){
                this.$emit('update:username', newValue)
            } 
        }

    },
    mounted() {
        this.fetchCategories();
    },
}
</script>  
           